import { inject } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import { DeviceDetector } from "../../interfaces/device-detector";

export class NgxDeviceDetectorAdapter implements DeviceDetector {

  private deviceDetectorService: DeviceDetectorService = inject(DeviceDetectorService)

  getUserAgent() {
    return this.deviceDetectorService.userAgent;
  }

  getOperationalSystem() {
    return this.deviceDetectorService.os;
  }

  isDesktop(userAgent?: string): boolean {
    return this.deviceDetectorService.isDesktop(userAgent);
  }

  setDeviceInfo(userAgent?: string) {
    this.deviceDetectorService.setDeviceInfo(userAgent);
  }
  
  getDeviceInfo() {
    return this.deviceDetectorService.getDeviceInfo()
  }
  
}